import { createFileRoute } from "@tanstack/react-router";
import { Bell } from "lucide-react";
import { useCallback } from "react";
import { z } from "zod";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { REQUEST_VIEWS, type RequestView } from "@/features/booking/modules/requests/request-views";
import { NotificationCenter } from "@/features/notifications/modules/notification-center/notification-center";
import { NOTIFICATION_TABS, type NotificationTab } from "@/features/notifications/notification-tabs";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/notifications/")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: m.notifications_title(),
    };
  },
  validateSearch: z.object({
    tab: z.enum(NOTIFICATION_TABS).optional(),
    view: z.enum(REQUEST_VIEWS).optional(),
    bookingId: z.string().optional(),
  }),
});

function RouteComponent() {
  const { tab, view } = Route.useSearch();
  const navigate = Route.useNavigate();

  const setTab = useCallback(
    (next: NotificationTab) => navigate({ to: "/notifications", search: { tab: next }, replace: true }),
    [navigate],
  );
  const setView = useCallback(
    (next: RequestView) => navigate({ to: "/notifications", search: { tab: "requests", view: next }, replace: true }),
    [navigate],
  );

  return (
    <PageShell icon={Bell} title={m.notifications_title()} description={m.notifications_page_description()}>
      <NotificationCenter tab={tab ?? "activity"} onTabChange={setTab} view={view} onViewChange={setView} />
    </PageShell>
  );
}
